"use strict";
// erp next defaults
Object.defineProperty(exports, "__esModule", { value: true });
exports.getCompanyByGeo = exports.getAllErpCompanies = exports.getCompaniesByGeo = exports.getCompanyByName = exports.TenderdInc = exports.TenderdLimited = exports.TenderdKSA = exports.TenderdDMCC = exports.TenderdLLC = exports.CompanyName = exports.ERPDocTypes = exports.MobAndDemobItems = exports.ItemGroups = exports.SaTerritories = exports.UaeTerritories = exports.RootTerritories = void 0;
const base_1 = require("../base");
var RootTerritories;
(function (RootTerritories) {
    RootTerritories["UnitedArabEmirates"] = "United Arab Emirates";
    RootTerritories["SaudiArabia"] = "Saudi Arabia";
})(RootTerritories = exports.RootTerritories || (exports.RootTerritories = {}));
var UaeTerritories;
(function (UaeTerritories) {
    UaeTerritories["AbuDhabi"] = "Abu Dhabi";
    UaeTerritories["Ajman"] = "Ajman";
    UaeTerritories["Dubai"] = "Dubai";
    UaeTerritories["Fujairah"] = "Fujairah";
    UaeTerritories["RasAlKhaimah"] = "Ras Al Khaimah";
    UaeTerritories["Sharjah"] = "Sharjah";
    UaeTerritories["UmmAlQuwain"] = "Umm Al Quwain";
})(UaeTerritories = exports.UaeTerritories || (exports.UaeTerritories = {}));
// TODO: decide what to keep for ksa territories
var SaTerritories;
(function (SaTerritories) {
    SaTerritories["Bahah"] = "Bahah";
    SaTerritories["NorthernBorders"] = "Northern Borders";
    SaTerritories["Jawf"] = "Jawf";
    SaTerritories["Madinah"] = "Madinah";
    SaTerritories["Qassim"] = "Qassim";
    SaTerritories["Riyadh"] = "Riyadh";
    SaTerritories["EasternProvince"] = "Eastern Province";
    SaTerritories["Asir"] = "Asir";
    SaTerritories["Ha'il"] = "Ha'il";
    SaTerritories["Jazan"] = "Jazan";
    SaTerritories["Makkah"] = "Makkah";
    SaTerritories["Najran"] = "Najran";
    SaTerritories["Tabuk"] = "Tabuk";
})(SaTerritories = exports.SaTerritories || (exports.SaTerritories = {}));
// item groups
var ItemGroups;
(function (ItemGroups) {
    ItemGroups["HireCharges"] = "Hire Charges";
    ItemGroups["MobAndDemob"] = "Mob & Demob";
    ItemGroups["EquipmentsSaudi"] = "Equipments - sa";
    ItemGroups["EquipmentsUae"] = "Equipments - uae";
    ItemGroups["LogisticsUae"] = "Logistics - uae";
    ItemGroups["LogisticsSa"] = "Logistics - sa";
    ItemGroups["Listings"] = "Listings";
    ItemGroups["OtherCharges"] = "Other Charges";
})(ItemGroups = exports.ItemGroups || (exports.ItemGroups = {}));
var MobAndDemobItems;
(function (MobAndDemobItems) {
    MobAndDemobItems["Mobilization"] = "Mobilization";
    MobAndDemobItems["Demobilization"] = "Demobilization";
    MobAndDemobItems["MobAndDemob"] = "Mobilization and Demobilization";
})(MobAndDemobItems = exports.MobAndDemobItems || (exports.MobAndDemobItems = {}));
var ERPDocTypes;
(function (ERPDocTypes) {
    ERPDocTypes["TaxCategory"] = "Tax Category";
    ERPDocTypes["PurchaseOrder"] = "Purchase Order";
    ERPDocTypes["ExpenseClaimAdvance"] = "Expense Claim Advance";
    ERPDocTypes["JournalEntryAccount"] = "Journal Entry Account";
    ERPDocTypes["Webhook"] = "Webhook";
    ERPDocTypes["PlaidSettings"] = "Plaid Settings";
    ERPDocTypes["Item"] = "Item";
    ERPDocTypes["SalaryStructureAssignment"] = "Salary Structure Assignment";
    ERPDocTypes["SalaryStructure"] = "Salary Structure";
    ERPDocTypes["HRSettings"] = "HR Settings";
    ERPDocTypes["ItemPrice"] = "Item Price";
    ERPDocTypes["SupplierQuotation"] = "Supplier Quotation";
    ERPDocTypes["DeliveryNote"] = "Delivery Note";
    ERPDocTypes["SalesInvoice"] = "Sales Invoice";
    ERPDocTypes["SalesOrder"] = "Sales Order";
    ERPDocTypes["Quotation"] = "Quotation";
    ERPDocTypes["QuotationItem"] = "Quotation Item";
    ERPDocTypes["QuotationContactTable"] = "Quotation Contact Table";
    ERPDocTypes["PurchaseInvoice"] = "Purchase Invoice";
    ERPDocTypes["PurchaseReceipt"] = "Purchase Receipt";
    ERPDocTypes["GSTHSNCode"] = "GST HSN Code";
    ERPDocTypes["ItemTax"] = "Item Tax";
    ERPDocTypes["Project"] = "Project";
    ERPDocTypes["Customer"] = "Customer";
    ERPDocTypes["CustomerCreditLimit"] = "Customer Credit Limit";
    ERPDocTypes["Supplier"] = "Supplier";
    ERPDocTypes["Account"] = "Account";
    ERPDocTypes["JournalEntry"] = "Journal Entry";
    ERPDocTypes["PaymentEntry"] = "Payment Entry";
    ERPDocTypes["PaymentEntryDeduction"] = "Payment Entry Deduction";
    ERPDocTypes["Opportunity"] = "Opportunity";
    ERPDocTypes["OpportunityItem"] = "Opportunity Item";
    ERPDocTypes["SalesInvoiceItem"] = "Sales Invoice Item";
    ERPDocTypes["ToDo"] = "ToDo";
    ERPDocTypes["File"] = "File";
    ERPDocTypes["Version"] = "Version";
    ERPDocTypes["Contact"] = "Contact";
    ERPDocTypes["Lead"] = "Lead";
    ERPDocTypes["Activity"] = "Activity";
    ERPDocTypes["ContactEmail"] = "Contact Email";
    ERPDocTypes["DynamicLink"] = "Dynamic Link";
    ERPDocTypes["Comment"] = "Comment";
    ERPDocTypes["AutoRenewLPO"] = "Auto Renew LPO";
    ERPDocTypes["RenewalHistory"] = "Renewal History";
    ERPDocTypes["ViewLog"] = "View Log";
    ERPDocTypes["Address"] = "Address";
    ERPDocTypes["InvoiceAcknowledgment"] = "Invoice Acknowledgement";
})(ERPDocTypes = exports.ERPDocTypes || (exports.ERPDocTypes = {}));
var CompanyName;
(function (CompanyName) {
    CompanyName["Tenderd"] = "Tenderd";
    CompanyName["TenderdINC"] = "Tenderd INC";
    CompanyName["TenderdDMCC"] = "Tenderd DMCC";
    CompanyName["TenderdLLC"] = "Tenderd LLC";
    CompanyName["TenderdKSA"] = "Tenderd KSA";
    CompanyName["TenderdLIMITED"] = "Tenderd LIMITED";
})(CompanyName = exports.CompanyName || (exports.CompanyName = {}));
exports.TenderdLLC = {
    name: CompanyName.TenderdLLC,
    abbr: 'TLLC',
    displayName: CompanyName.TenderdLLC,
};
exports.TenderdDMCC = {
    name: CompanyName.TenderdDMCC,
    abbr: 'TDMCC',
    displayName: 'Tenderd TRACK DMCC',
};
exports.TenderdKSA = {
    name: CompanyName.TenderdKSA,
    abbr: 'TKSA',
    displayName: CompanyName.TenderdKSA,
};
exports.TenderdLimited = {
    name: CompanyName.TenderdLIMITED,
    abbr: 'TL',
    displayName: CompanyName.TenderdLIMITED,
};
exports.TenderdInc = {
    name: CompanyName.TenderdINC,
    abbr: 'TINC',
    displayName: CompanyName.TenderdINC,
};
const getCompanyByName = (company) => {
    const nameCompanyMap = {
        [exports.TenderdDMCC.name]: exports.TenderdDMCC,
        [exports.TenderdLLC.name]: exports.TenderdLLC,
        [exports.TenderdKSA.name]: exports.TenderdKSA,
        [exports.TenderdLimited.name]: exports.TenderdLimited,
    };
    return nameCompanyMap[company];
};
exports.getCompanyByName = getCompanyByName;
const getCompaniesByGeo = (geo) => {
    if (geo === base_1.Geo.UAE) {
        return [
            exports.TenderdDMCC,
            exports.TenderdLLC,
            exports.TenderdLimited,
        ];
    }
    else if (geo === base_1.Geo.SA) {
        return [
            exports.TenderdKSA
        ];
    }
    return [];
};
exports.getCompaniesByGeo = getCompaniesByGeo;
const getAllErpCompanies = () => {
    return [
        exports.TenderdDMCC,
        exports.TenderdLLC,
        exports.TenderdKSA,
        exports.TenderdLimited,
    ];
};
exports.getAllErpCompanies = getAllErpCompanies;
// Mail Company for a geo for automated processes.
const getCompanyByGeo = (geo) => {
    if (geo === base_1.Geo.UAE) {
        return exports.TenderdDMCC;
    }
    else if (geo === base_1.Geo.SA) {
        return exports.TenderdKSA;
    }
    else if (geo === base_1.Geo.Test) {
        return exports.TenderdDMCC;
    }
    throw new Error('company not added for geo: ' + geo);
};
exports.getCompanyByGeo = getCompanyByGeo;
//# sourceMappingURL=erpnext.js.map